var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.568 54.357 L 88.568 54.357 c -8.337 -3.453 -8.337 -15.262 0 -18.715 h 0 c 1.183 -0.49 1.745 -1.847 1.255 -3.03 l -4.369 -10.547 c -0.49 -1.183 -1.847 -1.745 -3.03 -1.255 h 0 c -8.337 3.453 -16.687 -4.897 -13.233 -13.233 v 0 c 0.49 -1.183 -0.072 -2.54 -1.255 -3.03 L 57.388 0.177 c -1.183 -0.49 -2.54 0.072 -3.03 1.255 c -3.453 8.337 -15.262 8.337 -18.715 0 c -0.49 -1.183 -1.847 -1.745 -3.03 -1.255 L 22.065 4.546 c -1.183 0.49 -1.745 1.847 -1.255 3.03 c 3.453 8.337 -4.897 16.687 -13.234 13.234 c -1.183 -0.49 -2.54 0.072 -3.03 1.255 L 0.177 32.612 c -0.49 1.183 0.072 2.54 1.255 3.03 l 0 0 c 8.337 3.453 8.337 15.262 0 18.715 l 0 0 c -1.183 0.49 -1.745 1.847 -1.255 3.03 l 4.369 10.547 c 0.49 1.183 1.847 1.745 3.03 1.255 l 0 0 c 8.337 -3.453 16.687 4.897 13.233 13.234 v 0 c -0.49 1.183 0.072 2.54 1.255 3.03 l 10.547 4.369 c 1.183 0.49 2.54 -0.072 3.03 -1.255 v 0 c 3.453 -8.337 15.262 -8.337 18.715 0 v 0 c 0.49 1.183 1.847 1.745 3.03 1.255 l 10.547 -4.369 c 1.183 -0.49 1.745 -1.847 1.255 -3.03 v 0 c -3.453 -8.337 4.897 -16.687 13.234 -13.233 c 1.183 0.49 2.54 -0.072 3.03 -1.255 l 4.369 -10.547 C 90.313 56.204 89.751 54.848 88.568 54.357 z M 45 64.052 c -10.522 0 -19.052 -8.53 -19.052 -19.052 c 0 -10.522 8.53 -19.052 19.052 -19.052 S 64.052 34.478 64.052 45 C 64.052 55.522 55.522 64.052 45 64.052 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b38a2476364b48e524e76b72e376637b.svg";
export { ForwardRef as ReactComponent };